import React, { useState, useEffect } from 'react';
import { Icon, InputNumber, Tooltip } from "antd";
import { useTranslation } from 'react-i18next';
import InvestmentManagerHolder from '../../styles/InvestmentManagerStyle';
import CustomInputCurrency from '../../../../shared/components/CustomInputCurrency';
import Colors from '../../../../../themes/Colors';

const InvestmentManagerComponent = ({
  currency,
  value,
  onChange,
  disabled,
  step,
  style,
  tooltip,
  parentGroupInvestment = 0,
  readOnly = false,
}) => {

  const { t } = useTranslation();

  const handleInputChange = newValue => {
    if (newValue === null) return;
    onChange(newValue, 'default');
  };

  const handlePercentageChange = newPercentage => {
    if (newPercentage === null || isNaN(newPercentage)) return;
    const newInvestmentValue = (newPercentage / 100) * parentGroupInvestment;
    const fixedNewInvestmentValue = Number(newInvestmentValue).toFixed(2);
    onChange(Number(fixedNewInvestmentValue), 'percentage');
  };

  return (
    <InvestmentManagerHolder style={style}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <CustomInputCurrency
          currency={currency}
          value={value}
          onChange={handleInputChange}
          disabled={disabled || readOnly}
          step={step}
        />
      </div>

      {/* The tooltip only explains the percentage, so both go away together. */}
      {!readOnly && (
        <>
          <div
            className="percentage-input-container"
            onClick={e => e.stopPropagation()}
            onMouseDown={e => e.stopPropagation()}
          >
            <InputNumber
              value={value > 0 ? ((value / parentGroupInvestment) * 100).toFixed(2) : 0}
              formatter={value => `${value}%`}
              parser={value => value.replace('%', '')}
              onChange={handlePercentageChange}
              min={0}
              max={100}
              disabled={disabled}
              precision={2}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: '5px' }}>
            <Tooltip title={tooltip}>
              <Icon type="info-circle" style={{ color: Colors.primaryAccent, fontSize: 16 }} />
            </Tooltip>
          </div>
        </>
      )}
    </InvestmentManagerHolder>
  );
};

export default InvestmentManagerComponent;
